export default {
  dialogTitle: "BTC画布",
  description:
    "由于BTC数据格式的特殊性，画布中需要添加一个交易哈希作为初始数据。当前地址共包含",
  descriptionSuffix: "条哈希，请选择其中一条加入画布开始分析",
  table: {
    columns: {
      transactionHash: "交易哈希",
      transactionAmount: "交易数量",
      transactionTime: "交易时间",
      actions: "操作",
    },
    actions: {
      joinCanvas: "加入画布",
    },
  },
};
